import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  justify-content: space-between;
`
const Option = styled.button<{ isSelected?: boolean }>`
  background: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.borderSecondary};
  color: ${({ theme }) => theme.colors.textSecondary};
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  justify-content: center;
  line-height: 16px;
  padding: 10px;
  text-align: center;
  width: 125px;
  flex: 1 1 0px;
  margin: 0 10px;

  :first-of-type {
    margin-left: 0;
  }

  :last-of-type {
    margin-right: 0;
  }

  ${({ isSelected, theme }) =>
    isSelected &&
    `
    color: ${theme.colors.white};
    background: ${theme.colors.backgroundSecondary};
    `}
`

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  value?: string
  options: { value: string; label: string }[]
  handleChange(optionValue: string): void
  buttonProps?: React.HTMLAttributes<HTMLButtonElement>
}

export default function Checkbox({
  value,
  options,
  handleChange,
  buttonProps,
  ...props
}: Props) {
  return (
    <Container {...props}>
      {options.map((option) => (
        <Option
          isSelected={option.value === value}
          key={option.value}
          onClick={() => handleChange(option.value)}
          type="button"
          {...buttonProps}
        >
          {option.label}
        </Option>
      ))}
    </Container>
  )
}
